import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export const StepContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
  alignItems: 'flex-start',
  width: '100%'
}));

export const StepTagRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const StepTagChip = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.neutrals.beige3,
  borderRadius: 4,
  padding: theme.spacing(0.5, 1.5)
}));

export const StepTagLabel = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2R,
  color: theme.palette.neutrals.lead
}));

export const ContinueButtonRow = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  width: '100%'
}));
